const supplement = {
  getlist: 'supplement/getlist',
  add: 'supplement/add',
  update: 'supplement/update',
  remove: 'supplement/remove',
  get: 'supplement/get',
  getall: 'supplement/getall',
}
export default supplement
